"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const enums_1 = require("../../@shared-types/vehicle/enums");
const config_service_1 = require("../../../../shared/config/config.service");
let VehicleEmissionsComponent = class VehicleEmissionsComponent {
    constructor(configService) {
        this.configService = configService;
        this.emissionsChange = new core_1.EventEmitter();
        this.selectOptions = {};
        this.isEV = () => {
            var _a;
            if (((_a = this.modelData) === null || _a === void 0 ? void 0 : _a.engine.fuel.type) === enums_1.EFuelType.Electricity)
                return true;
            return false;
        };
        this.isPHEV = () => {
            var _a;
            switch ((_a = this.modelData) === null || _a === void 0 ? void 0 : _a.engine.fuel.type) {
                case enums_1.EFuelType.HybridDieselPlugin:
                case enums_1.EFuelType.HybridPetrolPlugin:
                    return true;
                default: return false;
            }
        };
        this.getFuelUnit = () => {
            var _a;
            switch ((_a = this.modelData) === null || _a === void 0 ? void 0 : _a.engine.fuel.type) {
                case enums_1.EFuelType.CNG:
                case enums_1.EFuelType.Hydrogen:
                    return 'kg/100 km';
                default: return 'l/100 km';
            }
        };
        this.addNewEmissionData = () => {
            /** Backward compatability for newly introduced values in 02/2024 */
            if (this.modelData && !this.emissions) {
                this.emissions = {
                    co2: {},
                    electricReach: {},
                    energyConsumption: {},
                    fuelConsumption: {},
                };
                this.emissionsChange.emit(this.emissions);
            }
        };
        this.selectOptions = {
            emissionClass: this.configService.getConstant(config_service_1.ConstantTypes.EMISSION_CLASS),
            emissionSticker: this.configService.getConstant(config_service_1.ConstantTypes.EMISSION_STICKER),
        };
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], VehicleEmissionsComponent.prototype, "emissions", void 0);
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", Object)
], VehicleEmissionsComponent.prototype, "emissionsChange", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], VehicleEmissionsComponent.prototype, "modelData", void 0);
VehicleEmissionsComponent = __decorate([
    (0, core_1.Component)({
        selector: 'vehicle-emissions',
        templateUrl: require('./emissions.component.html'),
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof config_service_1.ConfigService !== "undefined" && config_service_1.ConfigService) === "function" ? _a : Object])
], VehicleEmissionsComponent);
exports.default = VehicleEmissionsComponent;
